import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=772861b0&scoped=true"
import script from "./LanguageButton.vue?vue&type=script&lang=ts"
export * from "./LanguageButton.vue?vue&type=script&lang=ts"
import style0 from "./LanguageButton.vue?vue&type=style&index=0&id=772861b0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772861b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('772861b0')) {
      api.createRecord('772861b0', component.options)
    } else {
      api.reload('772861b0', component.options)
    }
    module.hot.accept("./LanguageButton.vue?vue&type=template&id=772861b0&scoped=true", function () {
      api.rerender('772861b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/LanguageButton.vue"
export default component.exports